
export const EnabelLine = () => {
    return (
        <svg width="26" height="34" viewBox="0 0 26 34" fill="green">
            <path d="M26 9v4c0 0.547-0.453 1-1 1h-1c-0.547 0-1-0.453-1-1v-4c0-2.203-1.797-4-4-4s-4 1.797-4 4v3h1.5c0.828 0 1.5 0.672 1.5 1.5v9c0 0.828-0.672 1.5-1.5 1.5h-15c-0.828 0-1.5-0.672-1.5-1.5v-9c0-0.828 0.672-1.5 1.5-1.5h10.5v-3c0-3.859 3.141-7 7-7s7 3.141 7 7z"></path>
        </svg>
    )
}